module.exports = __webpack_public_path__ + "static/ninja-8294c254a78f03c8809f47fd90f210e4.svg";